export const filter = () => {
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    if(getUrlParameter('cat')){
        const filter = document.querySelectorAll('.jet-radio-list__input[value="'+getUrlParameter('cat')+'"]');
        if(filter && filter[0]) setTimeout(()=>{filter[0].click(); }, 200);
        if(filter && filter[0]) {
            setTimeout(() => {
                filter[0].click();
            }, 200);
        }
    }

};

